import { Box, FormField, FormHelp, Heading, Label } from '@zillow/constellation-10';

import { TimeZoneDropdownSelect, TourDurationDropdownSelect } from '@zg-rentals/touring';

import { wizardFormSectionContainerStyles, wizardHeadingStyles } from '../../../../../styles/wizard';

import type { ComboboxOptionType } from '@zillow/constellation-10';
import type { TimeZoneIds } from '@zg-rentals/touring';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type TourSchedulingTimeZoneBodyProps = {
  selectedTimeZone?: TimeZoneIds;
  onSelectTimeZone: (option: ComboboxOptionType) => void;
  selectedTourDuration?: TourDuration;
  onSelectTourDuration: (option: ComboboxOptionType) => void;
};

const TourSchedulingTimeZoneBody = ({
  selectedTimeZone,
  onSelectTimeZone,
  selectedTourDuration,
  onSelectTourDuration,
}: TourSchedulingTimeZoneBodyProps) => {
  return (
    <div data-testid="TourSchedulingTimeZoneBody">
      <Box css={wizardFormSectionContainerStyles.raw()}>
        <Heading
          level={1}
          textStyle="heading-sm"
          css={wizardHeadingStyles}
          data-testid="TourSchedulingTimeZoneBody-Heading"
        >
          Tour settings
        </Heading>

        <FormField
          label={<Label size="lg">Length of each tour</Label>}
          control={
            <TourDurationDropdownSelect tourDuration={selectedTourDuration} handleOptionSelect={onSelectTourDuration} />
          }
          required={true}
          css={{ marginBottom: 'tight' }}
        />
        <FormField
          label={<Label size="lg">Property time zone</Label>}
          description={
            <FormHelp>
              This helps ensure that your tour availability matches what&apos;s provided to interested renters
            </FormHelp>
          }
          control={
            <TimeZoneDropdownSelect
              timeZone={selectedTimeZone}
              handleOptionSelect={onSelectTimeZone}
              disableTimeZoneSelection={false}
            />
          }
          required={true}
          css={{ marginBottom: 'tight' }}
        />
      </Box>
    </div>
  );
};

export default TourSchedulingTimeZoneBody;
